import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';
import { EVALUATION_STATE } from '../constants/Constants';

export default (state = initialState.podBased, action) => {
  switch (action.type) {
    case ActionTypes.GET_POD_BASED_EVALUATION_DETAILS: {
      return {
        ...state,
        testProject: {
          ...state.testProject,
          ...action.payload,
        },
      };
    }

    case ActionTypes.GET_POD_BASED_CURRENT_EVALUATION_ID: {
      return {
        ...state,
        testProject: {
          ...state.testProject,
          currentEvaluationEngineTaskId: action.payload,
        },
      };
    }

    case ActionTypes.RUN_POD_BASED_TEST_PROJECT: {
      return {
        ...state,
        testProject: {
          ...state.testProject,
          logUrl: action.payload,
        },
      };
    }

    case ActionTypes.GET_POD_BASED_EVALUATION_LOG: {
      const newState = {
        ...state,
        testProject: { ...state.testProject, ...action.payload },
      };

      if (
        action.payload?.logContentLength &&
        !newState.testProject.isLogContentLengthAvailable
      ) {
        newState.testProject.currentLogContentLength =
          action.payload?.logContentLength;
        newState.testProject.isLogContentLengthAvailable = true;
      }
      return newState;
    }

    case ActionTypes.RESET_IS_LOG_CONTENT_LENGTH_AVAILABLE: {
      return {
        ...state,
        testProject: {
          ...state.testProject,
          isLogContentLengthAvailable: false,
        },
      };
    }

    case `${ActionTypes.SET_POD_BASED_EVALUATION_STATE}_LOADING`: {
      return {
        ...state,
        testProject: {
          ...state.testProject,
          evaluationState: EVALUATION_STATE.LOADING,
        },
      };
    }

    case `${ActionTypes.SET_POD_BASED_EVALUATION_STATE}_EVALUATING`: {
      return {
        ...state,
        testProject: {
          ...state.testProject,
          evaluationState: EVALUATION_STATE.EVALUATING,
        },
      };
    }

    case `${ActionTypes.SET_POD_BASED_EVALUATION_STATE}_EVALUATED`: {
      return {
        ...state,
        testProject: {
          ...state.testProject,
          evaluationState: EVALUATION_STATE.EVALUATED,
        },
      };
    }

    case `${ActionTypes.SET_POD_BASED_TESTPROJECTSTATES}_UPDATE`: {
      return {
        ...state,
        testProjectStates: {
          ...state.testProjectStates,
          ...action.payload,
        },
      };
    }

    case `${ActionTypes.GET_TEST_PROJECT_DISABLED_SLUGS}_SUCCESS`: {
      return {
        ...state,
        testProject: {
          ...state.testProject,
          disabledSlugs: action.payload,
        },
      };
    }

    default: {
      return state;
    }
  }
};
